var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TableRender',{attrs:{"Service":_vm.Service}},[_c('TableText',{attrs:{"prop":"user.nickname","label":"昵称","width":160}}),_c('TableText',{attrs:{"prop":"name","label":"姓名","width":120}}),_c('TableText',{attrs:{"prop":"id_card","label":"身份证","width":180}}),_c('TableOptions',{attrs:{"prop":"status","label":"状态","width":100}}),_c('TableAction',{attrs:{"buttons":[
    { name: '编辑' },
    { name: '删除' }
  ],"minWidth":160}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }